module.exports = __webpack_public_path__ + "static/media/selfie.c8a1787e.png";